export const models = [
  {
    name: "数値",
    endpoint: "/digits",
    teachedList: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    strokeWidth: 1.5,
  },
  {
    name: "商品",
    endpoint: "/product",
    teachedList: [
      "大根",
      "キャベツ",
      "人参",
      "茄子",
      "卵",
      "トマト",
      "枝豆",
      "黒豆",
      "金柑",
      "にんにく",
    ],
    strokeWidth: 1,
  },
  {
    name: "等級",
    endpoint: "/rank",
    teachedList: ["A", "B", "C", "D", "秀", "優", "良", "外", "枝", "束"],
    strokeWidth: 1,
  },
  {
    name: "階級",
    endpoint: "/level",
    teachedList: ["4L", "3L", "2L", "L", "M", "S", "2S", "3S", "L大", "特"],
    strokeWidth: 1,
  },
  {
    name: "荷姿",
    endpoint: "/package",
    teachedList: [
      "木箱",
      "DB",
      "pk",
      "袋",
      "ネット",
      "カゴ",
      "コンテナ",
      "ポリ",
      "バラ",
      "グラス",
    ],
    strokeWidth: 1,
  },
];
